import { useQuery } from '@tanstack/react-query';

import { getAttractionOffers } from '~/services/AttractionsService';

import type { ListAttractionOffersParams } from '~/types/attractionTypes';

import { attractionQueryKeys } from './attractionQueryKeys';

interface UseGetAttractionOffersOptions {
  enabled?: boolean;
}

/**
 * Fetches offers matched to an attraction with pagination.
 */
export function useGetAttractionOffers(
  attractionId: string,
  params: ListAttractionOffersParams,
  options: UseGetAttractionOffersOptions = {},
) {
  const { enabled = true } = options;

  return useQuery({
    queryKey: [...attractionQueryKeys.offers(attractionId), params] as const,
    queryFn: async ({ signal }) => {
      return await getAttractionOffers(attractionId, params, { signal });
    },
    placeholderData: (previousData) => previousData,
    enabled: enabled && !!attractionId,
    retry: false,
  });
}
